import { Client } from "@sentry/core";
/**
 * Wires a JS client's integrations WITHOUT touching the native SDK. A non-owner native logger must
 * never call its own `client.init()`: `ReactNativeClient.init()` flips the shared, module-level
 * `NATIVE.enableNative` flag and disables the owner's native binding.
 */
const setupJsIntegrations = (client) => {
    Client.prototype.init.call(client);
};
export { setupJsIntegrations };
